export default {
  register: "Daftar",
  welcome: "Selamat Datang",
  textWelcome: "Selamat Datang",
  textGoodMorning: "Selamat pagi",
  textGoodAfternoon: "Selamat siang",
  textGoodEvening: "Selamat malam",
  textGoodNight: "Selamat tidur",
  loginFail: "Login gagal",
  phone: "Nomor Telepon",
  email: "Email",
  agreeTermAndCondition: "Setujui syarat & ketentuan",
  pleaseAgreeTermAndCondition: "Silakan setujui Kebijakan Privasi",
  back: "Kembali",
  termAndCondition: "Syarat dan Ketentuan",
  termAndCondition2: "Syarat dan Ketentuan",
  cancel: "Batal",
  confirm: "Konfirmasi",
  confirmDefault: "Konfirmasi",
  confirmRegistration: "Konfirmasi Pendaftaran",
  addItem: "Tambah Item",
  required: "Silakan isi kolom ini",
  zipcode: "Kode Pos",
  sub_district: "Kelurahan",
  district: "Kecamatan",
  province: "Provinsi",
  save: "Simpan",
  saveDraft: "Simpan Draf",
  close: "Tutup",
  name: "Nama",
  surname: "Nama Belakang",
  birthDay: "Tanggal Lahir",
  gender: "Jenis Kelamin",
  educationLevel: "Tingkat Pendidikan",
  jobLevel: "Tingkat Pekerjaan",
  jobPosition: "Jabatan",
  department: "Departemen",
  company: "Perusahaan",
  address: "Alamat",
  enterRegister: "Daftar",
  management: "Manajemen",
  manager: "Manajer",
  supervisor: "Supervisor",
  officer: "Staf/Petugas",
  worker: "Pekerja/Operator",
  doctorate: "Doktor (S3)",
  masterDegree: "Magister (S2)",
  bachelorDegree: "Sarjana (S1)",
  highVocational: "Diploma (D3/D4)",
  technicalVocational: "Pendidikan Vokasi",
  vocational: "SMK",
  highSchool: "SMA",
  secondarySchool: "SMP",
  primarySchool: "SD",
  lowerPrimary: "Di bawah SD",
  male: "Laki-laki",
  female: "Perempuan",
  other: "Lainnya",
  profile: "Profil",
  id: "ID",
  nameSurname: "Nama Lengkap",
  sendRefCodeOtp: "Kode Ref",
  requestOtpAgain: "Minta OTP Lagi",
  edit: "Ubah",
  add: "Tambah",
  addressSendReward: "Alamat Pengiriman",
  addressDetail: "Detail Alamat",
  selectDefautAddress: "Alamat Utama",
  addressEdit: "Ubah Alamat",
  addressAdd: "Tambah",
  defaultValue: "Nilai Standar",
  hello: "Halo Kak",
  coinTotal: "Total Poin",
  homePage: "Beranda",
  activityPage: "Aktivitas",
  redemptPage: "Tukar Hadiah",
  invitePage: "Undang Teman",
  connectPlatformPage: "Hubungkan Platform",
  connectPlatformPageHint: "E-Commerce untuk menerima hak istimewa khusus.",
  birthDayPage: "Hadiah Ulang Tahun",
  addressPage: "Alamat Pengiriman",
  favoritePage: "Favorit",
  cancelShipment: "Batalkan Pengiriman",
  couponPage: "Kupon Saya",
  myLuckyDrawPage: "Undian Saya",
  myMemberPage: "Keanggotaan Saya",
  registerMemberPage: "Daftar Anggota",
  statusDeliveryPage: "Cek Status Hadiah",
  transferPage: "Transfer Poin",
  logout: "Keluar",
  textCategory: "Kategori",
  categoryAll: "Semua",
  categoryRecommend: "Rekomendasi",
  categoryFood: "Makanan",
  categoryElectrical: "Elektronik",
  categoryAppliance: "Peralatan",
  categoryOther: "Lainnya",
  totalValue: "Sisa Stok",
  detail: "Detail",
  seeMoreDetail: "Lihat Detail",
  youWant: "Apakah Anda ingin ",
  delete: "Hapus",
  favoriteText: "di favorit Anda",
  waitingLoad: "Mohon Tunggu",
  expireTime: "Kedaluwarsa",
  coin: "Poin",
  surveyRegister: "Formulir Pendaftaran",
  later: "Nanti",
  redeem: "Tukar",
  redeemPoint: "Poin digunakan",
  confirmRedeem: "Apakah Anda yakin ingin menukar",
  confirmAdd: "Apakah Anda ingin menambahkan",
  inYourFav: "ke favorit Anda",
  confirmDelete: "Apakah Anda yakin ingin menghapus",
  fromYourFav: "dari favorit Anda",
  balance: "Saldo",
  inviteFrindDetail:
    "Undang teman Anda untuk menggunakan aplikasi. Saat teman Anda berhasil mendaftar,",
  received: "diterima",
  inviteFriend: "Undang Teman",
  inviteFriendPhoneText: "Masukkan nomor telepon yang ingin diundang",
  inviteFriendLineText: "Undang teman melalui LINE",
  fillPhone: "Masukkan Nomor Telepon Teman",
  historyRedeem: "Riwayat Penukaran",
  historyCode: "Riwayat Kode",
  resendCode: "Kirim Ulang Kode",
  coinAll: "Keseluruhan",
  coinReceived: "Poin Diterima",
  coinUsed: "Poin Digunakan",
  activityAll: "Semua Aktivitas",
  expireDate: "Tanggal Kedaluwarsa",
  note: "Catatan",
  enterNote: "Masukkan catatan...",
  checkIn: "Check-in",
  activityExpireDate: "Batas Waktu Aktivitas",
  collectCoin: "Kumpulkan Poin",
  valueItem: "Jumlah",
  missionReward: "Hadiah",
  activityJoin: "Ikuti Aktivitas",
  activityQr: "Scan Kode QR",
  activitySurvey: "Isi Survei",
  activityUpload: "Unggah Hasil Aktivitas",
  activityScanQr: "SCAN QR",
  scanCode: "Scan Kode",
  sendSurvey: "Kirim Survei",
  uploadFile: "Unggah Berkas",
  sizeFile: "Ukuran berkas tidak boleh lebih dari 10 MB",
  activityStatusJoin: "Aktivitas Diikuti",
  activityStatusWait: "Aktivitas Menunggu",
  activityStatusSuccess: "Aktivitas Berhasil",
  activityStatusReject: "Aktivitas Ditolak",
  activityStatusAll: "Semua Aktivitas",
  registerToReceive: "Daftar",
  confirmUseCoupon: "Konfirmasi penggunaan kupon",
  noteUseCoupon:
    "Kami menyarankan Anda menggunakan kupon saat berada di toko untuk menghindari kehilangan hak penggunaan.",
  noteAlertUseCoupon:
    "Kode akan dianggap sudah digunakan segera setelah Anda mengklik klaim.",
  codeDiscount: "Kode Diskon",
  errorQr: "Gagal memuat QR.",
  cancelRedemption: "Apakah Anda ingin membatalkan transaksi?",
  cancelRedemptionNote:
    "Anda tidak akan mendapatkan poin jika membatalkan transaksi.",
  statusDelivery: "Status Pengiriman Hadiah",
  statusSendIn7Day: "Dikirim dalam 7 hari",
  shippingInProcess: "Sedang Diproses",
  statusDeliverySuccess: "Berhasil Dikirim",
  statusDeliveryCancel: "Pengiriman Dibatalkan",
  trackingNumber: "Nomor Resi",
  receiveReward: "Terima Hadiah",
  copyText: "Disalin",
  confirmReceiveReward: "Konfirmasi penerimaan hadiah",
  activitySuggest: "Rekomendasi Aktivitas",
  pageNotFound: "Halaman Tidak Ditemukan",
  goBackPage: "Kembali ke Halaman Sebelumnya",
  goToLogin: "Ke Halaman Login",
  changeLanguage: "Bahasa",
  all: "semua",
  join: "ikut",
  joined: "joined",
  success: "berhasil",
  failed: "gagal",
  waiting: "menunggu",
  pending: "Tertunda",
  sent: "Dikirim",
  delivered: "Terkirim",
  textRequireOTPAgain: "Minta kode OTP baru dalam: ",
  welcomeActivity: "Selamat bergabung dalam aktivitas",
  errQr: "Kode QR tidak valid, silakan coba lagi.",
  requireExam: "Silakan lengkapi kuesioner.",
  uploadSuccess: "Hasil telah dikirim.",
  uploadWaiting: "Pemeriksaan akan dilakukan dalam 7 hari.",
  errDupActivity:
    "Anda telah menyelesaikan tugas ini. Silakan pilih aktivitas lain.",
  errExpireActivity: "Maaf, aktivitas telah berakhir.",
  errActivity: "Maaf, Anda tidak memenuhi syarat untuk aktivitas ini.",
  errFileUpload: "Ukuran berkas tidak boleh lebih dari 10 MB.",
  errMyLuckyDrawNotEnough: "Maaf, kesempatan Anda tidak mencukupi.",
  expireDateUse: "tanggal kedaluwarsa",
  registerPage: "Halaman Pendaftaran",
  shareActivity: "Bagikan Aktivitas",
  goToMission: "Lihat Aktivitas",
  menuActivity: "Aktivitas",
  menuRedeem: "Tukar Hadiah",
  menuCoupon: "Kupon Saya",
  privacyPolicy: "Kebijakan Privasi",
  favoriteCategory: "Favorit",
  deviceCategory: "Perangkat Elektronik",
  accessoryCategory: "Aksesoris Elektronik",
  healthCategory: "Kesehatan & Kecantikan",
  foodCategory: "Makanan & Minuman",
  babyCategory: "Bayi & Mainan",
  petCategory: "Hewan Peliharaan",
  homeCategory: "Rumah & Gaya Hidup",
  menCategory: "Fashion Pria",
  womenCategory: "Fashion Wanita",
  sportCategory: "Olahraga",
  travelCategory: "Perjalanan",
  reward: "Hadiah",
  missionComing: "Misi Mendatang",
  startDate: "Tanggal Mulai",
  endDate: "Tanggal Berakhir",
  home: "Beranda",
  activity: "Aktivitas",
  tracking: "Pelacakan",
  account: "Akun",
  historyCoupon: "Riwayat Kupon",
  rewardSoHot: "Hadiah Populer",
  hotMission: "Aktivitas Populer",
  recommendMission: "Rekomendasi Aktivitas",
  doneDetailMission: "Detail Partisipasi",
  detailMission: "Detail Aktivitas",
  newActivityUpload: "Kirim Ulang",
  errNotTimeForActivity: "Aktivitas ini belum dimulai.",
  news: "Berita",
  birthDayGift: "Hadiah Ulang Tahun",
  friendRecommend: "Rekomendasi Teman",
  friendRequest: "Permintaan Pertemanan",
  friendList: "Daftar Teman",
  rewardLimitReached: "Batas hadiah tercapai",
  limitReached: "Batas tercapai",
  limitReachedPerDay: "Batas harian tercapai",
  textComingSoon: "Segera Hadir",
  textTimeCannotJoin: "Di luar periode aktivitas",
  couponExpired: "Kupon Kedaluwarsa",
  myLuckyDrawExpire: "Kedaluwarsa",
  conditionCoin: "Syarat & ketentuan berlaku",
  rewardPrize: "Hadiah",
  agree: "Setuju",
  disagree: "Tidak Setuju",
  activityHeartToHeart: "Kirim Pesan",
  rewardComingSoon: "Segera Hadir",
  addMember: "Tambah Anggota",
  conditionEntryPass: "Syarat Masuk",
  letsJoin: "Gabung Sekarang",
  isUsed: "Sudah Ditukar",
  editProfile: "Ubah Profil",
  textProfile: "Profil",
  searchMissionOrReward: "Cari Aktivitas atau Hadiah",
  searchHistory: "Riwayat Pencarian",
  removeSearchHistory: "Hapus Riwayat Pencarian",
  messageActivityUpcoming: "Nantikan! Aktivitas baru akan segera hadir 🎉",
  messageActivityErrorReJoin:
    "Gagal.\nSilakan bergabung langsung dari halaman aktivitas.",
  errActivityAlreadyJoined: "Maaf, Anda sudah bergabung dalam aktivitas ini.",
  errActivityDataNotFound: "Maaf, data aktivitas tidak ditemukan.",
  redeemSuccessWithClaimInstruction:
    "Penukaran berhasil! Silakan klaim hadiah Anda di 'Kupon Saya'.",
  redeemSuccess: "Penukaran Berhasil",
  errRewardOutOfStock: "Maaf, stok hadiah ini sudah habis.",
  errRedeemFail: "Maaf, penukaran gagal. Silakan coba lagi.",
  textSorry: "Maaf,",
  errDataNotFound: "Maaf, data tidak ditemukan.",
  errSubmissionFailed: "Maaf, pengiriman gagal. Silakan coba lagi.",
  errRegistrationFailedContactAdmin:
    "Pendaftaran gagal. Silakan hubungi admin.",
  btnRedirectMyCoupon: "Ke Kupon Saya",
  infoCouponReadyMyCoupons: "Anda dapat menggunakan kupon di 'Kupon Saya'.",
  coinCost: "Poin Dibutuhkan",
  next: "Berikutnya",
  skip: "Lewati",
  otpVerified: "OTP Terverifikasi",
  successOTPVerified: "OTP Berhasil Terverifikasi",
  dataNotFound: "Data tidak ditemukan",
  version: "Versi",
  viewAll: "Lihat Semua",
  availableStock: "Sisa Item",
  expiredAt: "Berakhir dalam",
  expiredAt2: "Kadaluarsa pada",
  rewardToReceive: "Hadiah yang akan diterima",
  chooseRewardToReceive: "Pilih hadiah Anda",
  viewResultActivity: "Lihat Hasil Aktivitas",
  titleInvite:
    "{name} mengundang Anda untuk bergabung dengan program loyalitas kami dan dapatkan hadiah eksklusif.",
  thankYouForParticipatingActivity: "Terima kasih atas partisipasi Anda!",
  doActivityBy: "Tindakan oleh",
  textNotSpecified: "Tidak ditentukan",
  textIncognito: "Mode Samaran",
  viewHistory: "Lihat Riwayat",
  history: "Riwayat",
  locationName: "Nama Lokasi",
  location: "Lokasi",
  selectRedeemRewardLocation: "Pilih titik pengambilan",
  selectAddressSendReward: "Pilih alamat pengiriman",
  instructionAddAddressSendReward: "Silakan tambahkan alamat pengiriman.",
  textSelect: "Pilih",
  instructionEnterRegisteredPhone:
    "Jika sudah memiliki akun, masukkan nomor telepon terdaftar Anda.",
  instructionEnterRegisteredEmail:
    "Jika Anda sudah terdaftar, silakan masukkan email yang terdaftar.",
  textFirstRegistration: "Pendaftaran Pertama Kali",
  textClickHere: "Klik di sini",
  statusRegistrationSuccess: "Pendaftaran Berhasil",
  statusRegistrationFailed: "Pendaftaran Gagal",
  instructionUploadIDPassport: "Silakan unggah KTP atau Paspor.",
  textUploadIDPassport: "Unggah KTP / Paspor",
  rewardStartDate: "Tanggal Mulai Penukaran",
  rewardExpiredDate: "Tanggal Kedaluwarsa Hadiah",
  detailMyLuckyDraw: "Detail Partisipasi",
  date: "Tanggal",
  errUserNotFound: "Maaf, pengguna tidak ditemukan.",
  textSelectUser: "Pilih Pengguna",
  textSelectFile: "Pilih Berkas",
  textImageType: "Gambar",
  textVideoType: "Video",
  instructionSelectOrAddAddress:
    "Silakan pilih atau tambahkan alamat pengiriman.",
  instructionSelectRewardMission: "Silakan pilih {amount} hadiah.",
  textTopRanking: "Peringkat Atas",
  textRank: "Peringkat",
  textTotalAmount: "Total Jumlah",
  viewProfile: "Lihat Profil",
  addFriend: "Tambah Teman",
  cancelFriend: "Hapus Pertemanan",
  removeFriendSuccess: "Berhasil dihapus dari teman",
  instructionUploadImageVideo: "Unggah Gambar/Video (Maks {size}MB)",
  textUnsupportedFileType: "Tipe berkas tidak didukung.",
  textAdditionalDescription: "Deskripsi Tambahan",
  textDescription: "Deskripsi",
  textLocationOrBranchName: "Nama Lokasi / Cabang",
  textCheckInTime: "Waktu Check-in",
  textCheckOutTime: "Waktu Check-out",
  textLastUpdate: "Terakhir diperbarui",
  instructionLineReopenExternalBrowser:
    "Silakan buka kembali di browser eksternal untuk login.",
  errPhoneIsUsed: "Maaf, nomor telepon ini sudah digunakan.",
  textConditionEntryPassGamification: "Syarat Partisipasi",
  textFree: "Gratis",
  textCongratsReceived: "Selamat! 🎉 Anda menerima",
  happyBirthMonth: "Selamat Bulan Ulang Tahun!",
  happyBirthMonthWish:
    "Semoga hari spesial Anda dipenuhi kegembiraan, senyuman, dan hadiah yang layak Anda dapatkan! 🎁 Semoga tahun ini membawa yang terbaik bagi Anda!",
  confirmDeleteMember: "Apakah Anda yakin ingin menghapus anggota {name}?",
  removeMemberSuccess: "Anggota berhasil dihapus",
  removeMemberFail: "Gagal menghapus anggota",
  confirmEditProfile: "Apakah Anda ingin menyimpan perubahan profil?",
  bonusCoin: "Poin Bonus",
  receiveCoin: "Anda mendapatkan poin",
  status: "Status",
  checkSendCodeHistory: "Anda dapat menggunakan kupon di 'Kupon Saya'.",
  errTimeOut: "Maaf, waktu telah habis.",
  inviteHeadline: "Lebih banyak teman, lebih seru!",
  inviteFriendNow: "Undang teman Anda ke aplikasi sekarang!",
  copyInviteLink: "Salin Link Undangan",
  copyInviteLinkSuccess: "Link undangan berhasil disalin",
  detailScanQrCode: "Silakan sejajarkan Kode QR di tengah.",
  pleaseFill: "Silakan isi",
  comment: "Komentar",
  claimSpecialGift: "Klaim Hadiah Spesial",
  claimGift: "Klaim Hadiah",
  claimGiftSuccess: "Hadiah berhasil diklaim",
  list: "Daftar",
  summary: "Ringkasan",
  collected: "Terkumpul",
  collectedItemCount: "{count} item terkumpul",
  invalidPhoneNumber: "Silakan masukkan nomor telepon yang valid",
  duplicateData: "Data duplikat",
  saveSuccess: "Berhasil disimpan",
  uploadSuccessful: "Unggah berhasil",
  memberLevel: "Level Saat Ini",
  maxLevelReached: "Selamat! Anda telah mencapai level tertinggi. 🎉",
  // earnMoreForNextLevel:
  //   "Kumpulkan {nextLevelEarn} poin lagi untuk mencapai {nextLevelName}",
  earnMoreForNextLevel:
    "Kumpulkan {nextLevelEarn} lagi untuk mencapai {nextLevelName}",
  code: "Kode",
  codeNo: "Kode No. {no}",
  qrCode: "Kode QR",
  barCode: "Barcode",
  removeCache: "Hapus Cache",
  connect: "Hubungkan",
  luckyDrawCount: "Kesempatan",
  locationAccessDenied: "Gagal mengambil lokasi. Silakan izinkan akses lokasi.",
  viewing: "Sedang melihat",
  cameraError: {
    notAllowed: "Silakan berikan izin akses kamera",
    notFound: "ERROR: Kamera tidak ditemukan di perangkat ini",
    notSupported: "ERROR: Diperlukan konteks aman (HTTPS, localhost)",
    notReadable: "ERROR: Apakah kamera sedang digunakan?",
    overconstrained: "ERROR: Kamera tidak sesuai",
    streamApiNotSupported: "ERROR: Stream API tidak didukung di browser ini",
    insecureContext:
      "ERROR: Akses kamera hanya diizinkan di konteks aman. Gunakan HTTPS.",
    unknown: "ERROR: Kesalahan kamera ({error_name})",
  },
  error: {
    title: "Oops! Kesalahan",
    general: "Terjadi kesalahan. Silakan coba lagi.",
    unknown: "Terjadi kesalahan tidak diketahui",
    network: "Kesalahan jaringan. Silakan periksa koneksi Anda.",
    timeout: "Waktu permintaan habis.",
    notFound: "Maaf, data yang diminta tidak ditemukan.",
    unauthorized: "Anda tidak memiliki izin untuk mengakses ini.",
    sessionTimeout:
      "Sesi Anda telah berakhir. Silakan masuk kembali untuk melanjutkan.",
    heicNotSupported: "File HEIC/HEIF tidak didukung. Silakan gunakan JPG atau PNG.",
    imageSupported: "Hanya file JPG, JPEG, dan PNG yang didukung.",
    ocrProductNotFound: "Produk tidak ditemukan, tidak cocok dengan label yang dipindai.",
  },
  yourCodeIs: "Kode Anda adalah",
  validation: {
    required: "Wajib diisi.",
    phoneInvalid: "Nomor telepon tidak valid",
    emailInvalid: "Format email tidak valid",
    enterOTP: "Silakan masukkan OTP",
    otpInvalid: "OTP harus 6 digit",
    uploadLimit: "Maksimal {number} item diizinkan",
    numberInvalid: "Harus berupa angka",
    minCode: "Masukkan setidaknya satu kode",
    maxFilesAllowed: "Anda dapat mengunggah maksimal {count} berkas",
    invalidFileFormat: "Format berkas tidak valid. Silakan unggah berkas lain.",
  },
  redeemAmount: "Jumlah Penukaran: {quantity}",
  duration: "Durasi",
  webAccessDenied:
    "Akses Ditolak: Anda tidak memiliki izin untuk mengakses situs ini",
  webRedirecting: "Mengalihkan ke situs yang benar...",
  or: "Atau",
  notEnough: "Saldo tidak cukup",
  notAvailable: "Tidak tersedia.",
  amount: "Jumlah",
  message: "Pesan",
  loginLineLoading: "Memuat Login Line...",
  signinWithLine: "Masuk dengan Line",
  signinWithGoogle: "Masuk dengan Google",
  sampleImage: "Contoh Gambar",
  submitResult: "Kirim Hasil",
  submit: "Kirim",
  unit: {
    km: "Kilometer",
    cc: "CC",
    unit: "Satuan",
  },
  menuMain: "Utama",
  menuMore: "Lebih",
  menuChatRoom: "Inbox",
  menuInformationCenter: "Info Center",
  menuInformationCenterFull: "Information Center",
  menuCampaign: "Campaign",
  menuRequest: "Request",
  menuWarranty: "Warranty",
  joinedCampaigns: "Joined Campaigns",
  campaignTotalPoint: "Total Point",
  campaignTotalAmount: "Total Amount",
  allRequest: "All Requests",
  newRequest: "New Request",
  textFilter: "Filter",
  textSortBy: "Sort by",
  textUpdated: "updated",
  textAttachmentCount: "{count} Attachments",
  textAttachmentFile: "Attachment Files",
  textFilePreview: "File Preview",
  textReply: "Reply",
  textReplyForm: "Reply Form",
  textForm: "Form",
  textFillInForm: "Fill in form",
  textPost: "Post",
  textInputComment: "Comment",
  textViewMoreComment: "View more comments",
  textViewMoreReply: "View more replies",
  textRewardCount: "× {count} item(s)",
  filterAll: "All",
  filterFavorite: "Favorited",
  filterUnread: "Unread",
  filterNoType: "No Type",
  filterReportStatus: "Status : {report_status_name}",
  sortDate: "Sort by Date",
  sortTitle: "Sort by Title",
  sortExpiredDate: "Sort by Expired Date",
  sortProduct: "Sort by Product",
  sortRegisterDate: "Sort by Register Date",
  clear: "Clear",
  addFavorite: "Add to Favorites",
  removeFavorite: "Remove from Favorites",
  extraBonus: "Extra Bonus",
  deliveryPickup: "Pickup",
  deliveryThailandPost: "Thailand Post",
  pleaseFillDetail: "please input detail here ...",
  textTitle: "Title",
  textSubtitle: "Subtitle",
  textType: "Type",
  textProduct: "Product",
  hintUploadMultiFile:
    "Max {fileLimit} files, maximum total file size is {fileLimitMB} MB",
  errorUploadLimitFileSize:
    "Total file size exceeds the {fileLimitMB} MB limit.",
  specialReward: "Claim your special reward!",
  totalSummaryPoint: "Total Points",
  transferPoint: "Transfer Points",
  confirmTransferPoint:
    "Are you sure you want to transfer {point} points to {name}?",
  transferSuccess: "Points transferred successfully",
  transferDescription: "Transfer points to another member",
  selectRecipient: "Select recipient",
  selectMember: "Select member",
  enterTransferPoints: "Enter the number of points to transfer",
  transferPointAmount: "Points to transfer",
  transferPointType: "Type of Points to Transfer",
  transferPoints: "Transfer points",
  totalPoint: "Total point",
  myPointAll: "All",
  myPointExpire: "Expiring Soon",
  myPointExchange: "Redeem",
  total: "Total",
  toMember: "To",
  remaining: "Remaining",
  max: "Max",
  allWarranty: "All Warranties",
  warranty: "Warranty",
  warrantyRegistration: "Warranty Registration",
  newProductWarranty: "New Product",
  registerWarrantyDescription: "Register your purchase to activate your warranty.",
  registerNow: "Register Now",
  serviceRequest: "Service Request",
  warrantyStatus: {
    active: "ACTIVE",
    pending: "PENDING",
    rejected: "REJECTED",
    expired: "EXPIRED",
  },
  textUploadProductLabel: "Upload Product Label",
  textAutoFillByAI: "Auto-fill details with AI ✨",
  textBtnSelectPhoto: "Select Photo",
  textViewSamplePhoto: "View sample photo",
  textNumberMore: "+{number} more",
  textHide: "hide",
  microsite: {
    invalidPhoneNumber: "Please enter a valid phone number",
    otpVerified: "Confirm OTP",
    sendRefCodeOtp: "Ref OTP",
    textRequireOTPAgain: "Request a new OTP code again within : ",
    requestOtpAgain: "Request OTP Again",
    confirmDefault: "Confirm",
    enterOTP: "Please enter the OTP",
    otpInvalid: "OTP must be 6 digits",
    textTransactionDetail: "Transaction Detail",
    createdAt: "Date",
    summary_amount: "Summary Amount",
    point: "Point",
    status: "Status",
    status_detail: "Status Detail",
    item_name: "Item Name",
    item_image: "Item Image",
    Approved: "Approved",
    Waiting: "Waiting Approval",
    Rejected: "Rejected",
    Pending: "Pending",
    privacyPolicy: "Privacy<br />policy",
    termAndCondition: "Terms &<br />conditions",
    textNext: "Next",
    acceptConsent: "I accept",
    dataNotFound: "Data Not Found",
    maxFileSizeAllowed: "File Size is less than {size} MB.",
    maxFilesAllowed: "You can upload maximum {count} files",
    errSubmissionFailed: "Sorry, your submission failed.",
    errGeneral: "Something went wrong. Please try again.",
    successOTPVerified: "OTP Verified successfully",
    textBack: "Back",
    errActivityAlreadyJoined: "Sorry, you have already joined this activity.",
    textRefresh: "Refresh",
    errActivity: "Sorry, you cannot join this activity.",
    textRegistrationHistory: "REGISTRATION HISTORY",
    textTotalPoint: "Total point",
    textTotalAmount: "Total amount",
    textHistory: "HISTORY",
    textNo: "No",
    textCode: "Code",
    textSuccess: "Success",
    textNotFound: "Not Found",
    textUsed: "Used",
    errUserNotFound: "Sorry, user not found.",
    loginSuccess: "Login successful.",
    registerSuccess: "Register successful.",
    textResultsSummary: "Results Summary",
    textTopRankingCampaign: "Top {num} Ranking",
    textRank: "Rank",
    textPhone: "Phone Number",
    textTotal: "Total",
    textLuckyDrawClaimed:
      "You have already claimed your Lucky Draw rights for this campaign.",
    textContactAdminToChange:
      "To change your selection, please contact administrator.",
    textConnectWithLine: "Connect with LINE",
    textBackHome: "Home",
  },
};
